
import React from 'react';
import { EmptyContentViewer } from './EmptyContentViewer';

interface TrainingFallbackContentViewerProps {
  fileUrl?: string | null;
  fileType?: string | null;
}

export function TrainingFallbackContentViewer({
  fileUrl,
  fileType
}: TrainingFallbackContentViewerProps) {
  const message = `This file type (${fileUrl?.split('.').pop() || fileType || 'unknown'}) is not supported in the current view. File URL: ${fileUrl || 'None'}`;
  
  return (
    <EmptyContentViewer message={message} />
  );
}
